export default status => dispatch => {
    dispatch({
        type: "SET_IS_TOUCH_DEVICE_STATUS",
        payload: status
    })
}